/* sugar:assets/collapsible-row-heading-icon.js@2.0.0 */
/**
 * Collapsible Heading Icon: moves each icon from the row's panel, where the row renders its
 * child blocks, to the front of the row's header.
 *
 * Every heading icon on a page loads this file (the browser fetches it once). Each run places the
 * icons still waiting in a panel, so markup that arrives later (the theme editor, a section
 * rendered again) picks up its own. The header holds each icon's space until it lands
 * (block-collapsible-row-heading-icon.css), so the move shifts nothing.
 */
(function () {
  function place(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var icons = root.querySelectorAll('.collapsible-row__content-inner > * > .sugar-collapsible-row-heading-icon');
    var moves = [];
    for (var i = 0; i < icons.length; i++) {
      var row = icons[i].closest('[data-accordion]');
      var header = row ? row.querySelector('[data-accordion-trigger]') : null;
      if (header) moves.push([header, icons[i]]);
    }
    for (var j = 0; j < moves.length; j++) {
      moves[j][0].insertBefore(moves[j][1], moves[j][0].firstChild);
    }
  }

  place(document);

  if (window.__sugarRowIconsBound) return;
  window.__sugarRowIconsBound = true;
  document.addEventListener('shopify:section:load', function (e) {
    place(e.target);
  });
})();
